import Vue from 'vue';

export default {
  async getProfitStats(from, to, methods) {
    return (await Vue.http.post('/api/stats/client/profit', { from, to, methods })).data;
  },
  async getGamesStats(from, to) {
    return (await Vue.http.post('/api/stats/client/games', { from, to })).data;
  },
  async getPlayerStats() {
    return (await Vue.http.post('/api/stats/clients/players')).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/stats.service.js